import { getSentryClient } from '../sentry'

export function reportSentryError(inputError: Error | string): void {
  const error = typeof inputError === 'string' ? new Error(inputError) : inputError

  // Report to Sentry
  getSentryClient().report(error)
}
